import { render, staticRenderFns } from "./AddMiembroModal.vue?vue&type=template&id=687c9b24"
import script from "./AddMiembroModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMiembroModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports